module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-autocomplete', {
    attrs: {
      "label": _vm.attributePanel ? '' : _vm.label,
      "dark": _vm.attributePanel,
      "filled": _vm.filled,
      "outlined": !_vm.filled,
      "disabled": _vm.disabled && !_vm.filled,
      "dense": "",
      "clearable": !_vm.disabled,
      "items": _vm.options,
      "item-text": "Name",
      "item-value": "Value",
      "readonly": _vm.disabled,
      "search-input": _vm.search,
      "return-object": "",
      "hide-details": "true"
    },
    on: {
      "input": function (val) { return _vm.update(val); },
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "update:search-input": function($event) {
        _vm.search = $event
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61f8fad8","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/components/AdvertiserSelect.vue
// module id = 2092
// module chunks = 0